import { DISCIPLINA_SITUACAO_AGUARDANDO_TRANSPOSICAO } from "@/common/disciplinaSituacao.util";
import { object } from "@/common/object.util";
import ApiAdmin from "@/services/apiAdmin.service";
import ApiGael from "@/services/apiGael.service";
import {
  FETCH_ALL,
  FETCH_ALL_EMENTA_PDF,
  FETCH,
  FETCH_FOR_URL_PREVIEW
} from "@/store/actions/actions.type";
import {
  FETCH_ALL_START,
  FETCH_ALL_PDF_EMENTA_START,
  SET_ALL,
  FETCH_ALL_END,
  FETCH_ALL_PDF_EMENTA_END,
  FETCH_START,
  SET,
  SET_UNIDADES,
  SET_UNIDADES_FROM_GAEL,
  FETCH_END
} from "@/store/mutations/mutations.type";

const defaults = Object.freeze({
  disciplina: {
    id: undefined,
    hash: "",
    nome: "",
    nomesAlternativos: [],
    fornecedor: {
      id: undefined
    },
    disciplinaSituacao: {
      id: DISCIPLINA_SITUACAO_AGUARDANDO_TRANSPOSICAO
    },
    autores: [],
    unidades: [],
    documentos: []
  }
});

const state = {
  disciplinas: {
    current_page: 1,
    per_page: 10,
    data: [],
    filters: []
  },
  disciplina: object.clone(defaults.disciplina),
  disciplinaOriginal: object.clone(defaults.disciplina),
  isFetchingDisciplinas: false,
  isFetchingDisciplina: false,
  isFetchingPdfEmentaDisciplinas: false,
  unidadesGael: []
};

const getters = {
  unidadesGael(state) {
    return state.unidadesGael;
  },
  disciplinas(state) {
    return state.disciplinas;
  },
  isFetchingDisciplinas(state) {
    return state.isFetchingDisciplinas;
  },
  isFetchingPdfEmentaDisciplinas(state) {
    return state.isFetchingPdfEmentaDisciplinas;
  },
  disciplina(state) {
    return state.disciplina;
  },
  disciplinaOriginal(state) {
    return state.disciplinaOriginal;
  },
  isFetchingDisciplina(state) {
    return state.isFetchingDisciplina;
  }
};

const actions = {
  [FETCH_ALL](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_ALL_START);

      ApiGael.query("scout/disciplinas/list", params)
        .then(response => {
          context.commit(SET_ALL, response.data);
          resolve(response.data);
        })
        .catch(e => {
          console.log(e);
          reject(e.response.data);
        })
        .finally(() => {
          context.commit(FETCH_ALL_END);
        });
    });
  },
  [FETCH_ALL_EMENTA_PDF](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_ALL_PDF_EMENTA_START);

      ApiGael.getPdf("disciplinas/ementa-pdf", params)
        .then(response => {
          var blob = new Blob([response.data], {
            type: "application/pdf"
          });
          var url = window.URL.createObjectURL(blob);

          var anchor = document.createElement("a");
          anchor.href = url;
          var date = new Date().toLocaleDateString("pt-BR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          });
          anchor.download = `EaDStock - Disciplinas ${date}`;
          anchor.click();
          resolve();
        })
        .catch(e => {
          console.log(e);

          reject(e.response);
        })
        .finally(() => {
          context.commit(FETCH_ALL_PDF_EMENTA_END);
        });
    });
  },
  [FETCH_FOR_URL_PREVIEW](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_START);
      context.commit(SET, object.clone(defaults.disciplina));

      if (!params) {
        context.commit(FETCH_END);
        resolve();
        return;
      }
      ApiAdmin.get("rents/unidades/urls", params.rentId)
        .then(response => {
          if (response.data) {
            context.commit(SET, response.data);
            resolve();
          }
        })
        .finally(() => {
          context.commit(FETCH_END);
        });
    });
  },
  [FETCH](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_START);
      context.commit(SET, object.clone(defaults.disciplina));

      if (!params) {
        context.commit(FETCH_END);
        resolve();
        return;
      }
      ApiGael.get("disciplinas/get", params)
        .then(response => {
          if (response.data.id) {
            context.commit(SET, response.data);
            resolve(response.data);
          } else {
            reject({ notFound: true });
          }
        })
        .catch(e => {
          console.log(e);
          reject(false);
        })
        .finally(() => {
          context.commit(FETCH_END);
        });
    });
  }
};

const mutations = {
  [FETCH_ALL_START](state) {
    state.isFetchingDisciplinas = true;
  },
  [FETCH_ALL_PDF_EMENTA_START](state) {
    state.isFetchingPdfEmentaDisciplinas = true;
  },
  [SET_ALL](state, disciplinas) {
    state.disciplinas = disciplinas;
  },
  [FETCH_ALL_END](state) {
    state.isFetchingDisciplinas = false;
  },
  [FETCH_START](state) {
    state.isFetchingDisciplina = true;
  },
  [SET](state, disciplina) {
    state.disciplina = disciplina;
    state.disciplinaOriginal = object.clone(disciplina);
  },
  [SET_UNIDADES_FROM_GAEL](state, unidadesGael) {
    state.unidadesGael = unidadesGael;
  },
  [SET_UNIDADES](state, unidades) {
    state.disciplina = unidades;
  },
  [FETCH_END](state) {
    state.isFetchingDisciplina = false;
  },
  [FETCH_ALL_PDF_EMENTA_END](state) {
    state.isFetchingPdfEmentaDisciplinas = false;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
